module.exports = __webpack_public_path__ + "img/icon_vip_free_btn.ee28bbe3.png";